function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import axios from 'axios';
var kingUrlMap = {
  local: 'https://api.cloud.wozp.cn',
  dev: 'https://api.cloud.wozp.cn',
  test: 'https://api.cloud.wozp.cn',
  pre: 'https://api-pre.cloud.wozp.cn',
  pro: 'https://api.cloud.wozhipei.com'
};
var formatSearch = function formatSearch(searchStr) {
  var queryString = searchStr.slice(searchStr.indexOf('?') + 1);
  var params = {};
  queryString.split('&').forEach(function (item) {
    var _item$split = item.split('='),
      _item$split2 = _slicedToArray(_item$split, 2),
      key = _item$split2[0],
      value = _item$split2[1];
    if (key) {
      params[key] = value;
    }
  });
  return params;
};

/**
 *  清除token时url:
 *  @query clearTicket
 *  @query syncSuccessUrl
 *
 *  更新token时url:
 *  @query ticket
 *  @query organization 组织code
 *  @query identity 身份code
 *  @query syncSuccessUrl 换取成功后前往地址
 *  @query syncFailUrl 换取失败后前往地址
 *
 */
var syncTicket = function syncTicket(_ref) {
  var env = _ref.env;
  return new Promise(function (resolve) {
    var Http = axios.create({
      baseURL: kingUrlMap[env],
      headers: {
        'Content-Type': 'application/json'
      }
    });
    var search = location.search || '';
    var searchObj = formatSearch(search);
    var ticket = searchObj.ticket,
      organization = searchObj.organization,
      identity = searchObj.identity,
      _searchObj$clearTicke = searchObj.clearTicket,
      clearTicket = _searchObj$clearTicke === void 0 ? false : _searchObj$clearTicke,
      _searchObj$syncSucces = searchObj.syncSuccessUrl,
      syncSuccessUrl = _searchObj$syncSucces === void 0 ? '' : _searchObj$syncSucces,
      _searchObj$syncFailUr = searchObj.syncFailUrl,
      syncFailUrl = _searchObj$syncFailUr === void 0 ? '' : _searchObj$syncFailUr;
    var url = '';
    /** 当指定是清除token时，返回清除token和清除后需要前往的地址*/
    if (clearTicket) {
      url = decodeURIComponent(decodeURIComponent(syncSuccessUrl));
      resolve({
        success: true,
        clearToken: true,
        url: url
      });
    } else {
      if (ticket) {
        /** 当获取到ticket时，通过ticket换取token*/
        Http.request({
          url: '/auth/user/v1/token_by_random_code',
          method: 'get',
          params: {
            randomCode: ticket
          }
        }).then(function (res) {
          var _ref2 = res || {},
            resData = _ref2.data;
          var data = resData.data;
          if (data) {
            url = syncSuccessUrl ? decodeURIComponent(decodeURIComponent(syncSuccessUrl)) : '';
            resolve({
              success: true,
              token: data,
              organization: organization,
              identity: identity,
              url: url
            });
          } else {
            url = syncFailUrl ? decodeURIComponent(decodeURIComponent(syncFailUrl)) : '';
            resolve({
              success: false,
              url: url
            });
          }
        }).catch(function () {
          url = syncFailUrl ? decodeURIComponent(decodeURIComponent(syncFailUrl)) : '';
          resolve({
            success: false,
            url: url
          });
        });
      } else {
        url = syncFailUrl ? decodeURIComponent(decodeURIComponent(syncFailUrl)) : '';
        resolve({
          success: false,
          url: url
        });
      }
    }
  });
};
export default syncTicket;